import React from 'react';
import PropTypes from 'prop-types';
import { cn } from 'lib/utils';
import FilterAutocomplete from 'tailwind-components/FilterAutocomplete/FilterAutocomplete';

function AgencyAppointmentsFilters({
  showAgencyPicker,
  agencyFilterOptions,
  selectedAgencies,
  onAgenciesChange,
  showAgentFiltersRow,
  agentOptions,
  carrierOptions,
  statusOptions,
  selectedAgents,
  selectedCarriers,
  selectedStatuses,
  onAgentsChange,
  onCarriersChange,
  onStatusesChange,
  disabled = false
}) {
  const gridClass =
    showAgencyPicker && showAgentFiltersRow
      ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 lg:items-end'
      : showAgentFiltersRow
      ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 lg:items-end'
      : 'grid-cols-1';

  const hasMultipleAgencies = agencyFilterOptions.length > 1;

  return (
    <div
      className={cn(
        'grid w-full shrink-0 gap-x-3 gap-y-3 rounded-lg',
        gridClass
      )}
    >
      {showAgencyPicker ? (
        <div
          className={cn(
            'flex min-h-px min-w-0 flex-col gap-1',
            showAgentFiltersRow && 'sm:col-span-2 lg:col-span-1'
          )}
        >
          <span className='text-sm font-medium text-grey sm:text-base'>
            Agency
          </span>
          <FilterAutocomplete
            options={agencyFilterOptions}
            value={selectedAgencies}
            onChange={onAgenciesChange}
            placeholder='All agencies'
            getOptionLabel={o => o.name}
            isOptionEqualToValue={(a, b) => a.value === b.value}
            disabled={disabled}
          />
        </div>
      ) : null}
      {showAgentFiltersRow ? (
        <>
          <div className='flex min-h-px min-w-0 flex-col gap-1'>
            <span className='text-sm font-medium text-grey sm:text-base'>
              Agents
            </span>
            <FilterAutocomplete
              options={agentOptions}
              value={selectedAgents}
              onChange={onAgentsChange}
              placeholder='All agents'
              getOptionLabel={o => o.name}
              isOptionEqualToValue={(a, b) => a.id === b.id}
              getOptionSecondaryLabel={hasMultipleAgencies ? (o => o.agencyName) : undefined}
              disabled={disabled}
            />
          </div>
          <div className='flex min-h-px min-w-0 flex-col gap-1'>
            <span className='text-sm font-medium text-grey sm:text-base'>
              Carriers
            </span>
            <FilterAutocomplete
              options={carrierOptions}
              value={selectedCarriers}
              onChange={onCarriersChange}
              placeholder='All carriers'
              getOptionLabel={o => o}
              isOptionEqualToValue={(a, b) => a === b}
              disabled={disabled}
            />
          </div>
          <div className='flex min-h-px min-w-0 flex-col gap-1 sm:col-span-2 lg:col-span-1'>
            <span className='text-sm font-medium text-grey sm:text-base'>
              Status
            </span>
            <FilterAutocomplete
              options={statusOptions}
              value={selectedStatuses}
              onChange={onStatusesChange}
              placeholder='All statuses'
              getOptionLabel={o => o}
              isOptionEqualToValue={(a, b) => a === b}
              disabled={disabled}
            />
          </div>
        </>
      ) : null}
    </div>
  );
}

AgencyAppointmentsFilters.propTypes = {
  showAgencyPicker: PropTypes.bool.isRequired,
  agencyFilterOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    })
  ).isRequired,
  selectedAgencies: PropTypes.array.isRequired,
  onAgenciesChange: PropTypes.func.isRequired,
  showAgentFiltersRow: PropTypes.bool.isRequired,
  agentOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      agencyName: PropTypes.string
    })
  ).isRequired,
  carrierOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  statusOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedAgents: PropTypes.array.isRequired,
  selectedCarriers: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedStatuses: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAgentsChange: PropTypes.func.isRequired,
  onCarriersChange: PropTypes.func.isRequired,
  onStatusesChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default AgencyAppointmentsFilters;
